const PAGES_OFFSET = 1

export const getAllPagesIndexes = (nbPages: number): number[] =>
  new Array(nbPages).fill(null).map((x, index) => index + 1)

export const filterPageIndexes = (allPages: number[], currentPage: number) => {
  const rightOffset = Math.max(0, PAGES_OFFSET - currentPage + 1)
  return allPages.filter(
    (index) =>
      index >= currentPage - PAGES_OFFSET &&
      index <= currentPage + PAGES_OFFSET + rightOffset
  )
}

export const isFirstPage = (currentRefinement: number) => currentRefinement <= 1

export const isLastPage = (currentRefinement: number, nbPages: number) =>
  currentRefinement >= nbPages
